var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.1,
    height: 16.1,
    viewBox: "0 0 16.1 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "minus-circle-outline",
    d: "M10.05,16.49a6.44,6.44,0,1,1,6.44-6.44,6.449,6.449,0,0,1-6.44,6.44M10.05,2a8.05,8.05,0,1,0,8.05,8.05A8.05,8.05,0,0,0,10.05,2M6.025,10.855h8.05V9.245H6.025",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleOutline);
export default __webpack_public_path__ + "static/media/minus_circle_outline.a2c3986984176f99f0e40960a62bddeb.svg";
export { ForwardRef as ReactComponent };